import { Button, Flex, FormControl, FormErrorMessage, FormLabel, HStack, Input, Textarea, useToast, VStack } from '@chakra-ui/react'
import { useMemo } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { BsArrowCounterclockwise, BsBoxArrowInDown, BsX } from 'react-icons/bs'
import Email, { createEmail, updateEmail } from '../../classes/Email'
import { AL_CREATE, AL_EDIT, reload, useSelectedItemAlertContext } from '../../context/selectedItemAlertContext'
import { useUserContext } from '../../context/userContext'
import { toastErrDesc, toastVal } from '../../utils/toastUtils'
import { SectionForm, SelectEmailType } from '../shared'

const EmailForm = ({ defaultData, close, mode = AL_CREATE }) => {
    const defaultValues = useMemo(() => {
        if (defaultData) {
            return defaultData
        }
        else {
            return {
                name: "",
                title: "",
                body: "",
                note: "",
                email_type: { value: "Approve", label: "ตรวจเอกสารคำร้อง" }
            }
        }
    }, [defaultData])

    const { control, handleSubmit, formState: { errors }, reset } = useForm({ defaultValues: defaultValues })
    const { userData } = useUserContext()
    const { setItemData } = useSelectedItemAlertContext()
    const toast = useToast()

    const resetForm = () => {
        reset(defaultValues)
    }
    const onSubmit = async (data) => {
        const emailData = new Email(data)
        if (mode === AL_CREATE) {
            await createEmail(emailData.serialized(), userData.token)
                .then(res => {
                    toast(toastVal({
                        title: "การบันทึกข้อมูลสำเร็จ",
                        description: `บันทึกข้อมูล เรียบร้อยแล้ว`,
                    }))
                    setItemData((prev) => reload(prev))
                    close()
                })
                .catch(error => {
                    toast(toastVal({
                        title: "การบันทึกข้อมูล ไม่สำเร็จ",
                        description: toastErrDesc(error),
                        status: "error",
                    }))
                })
        } else if (mode === AL_EDIT) {
            await updateEmail(defaultData?.id, emailData.serialized(), userData.token)
                .then(res => {
                    toast(toastVal({
                        title: "การบันทึกข้อมูลสำเร็จ",
                        description: `บันทึกการแก้ไขข้อมูล เรียบร้อยแล้ว`,
                    }))
                    setItemData((prev) => reload(prev))
                    close()
                })
                .catch(error => {
                    toast(toastVal({
                        title: "การบันทึกข้อมูล ไม่สำเร็จ",
                        description: toastErrDesc(error),
                        status: "error",
                    }))
                })
        }
    }
    return (
        <Flex w="full" >
            <form onSubmit={handleSubmit(onSubmit)} style={{ width: "100%" }}>
                <VStack w="full" spacing={2} >
                    <SectionForm header="ข้อมูลแบบอีเมล" >
                        <FormControl isInvalid={errors.name} isRequired>
                            <FormLabel>ชื่อแบบ</FormLabel>
                            <Controller
                                name="name"
                                control={control}
                                rules={{ required: true, maxLength: 100 }}
                                render={({ field }) => <Input placeholder="กรอกชื่อแบบอีเมล" {...field} />} />
                            <FormErrorMessage>กรุณากรอกข้อมูล ขนาดข้อความไม่ยาวเกิน 100 ตัวอักษร</FormErrorMessage>
                        </FormControl>
                        <FormControl isInvalid={errors.title} isRequired>
                            <FormLabel>ชื่อเรื่อง</FormLabel>
                            <Controller
                                name="title"
                                control={control}
                                rules={{ required: true, maxLength: 200 }}
                                render={({ field }) => <Input placeholder="กรอกชื่อเรื่อง" {...field} />} />
                            <FormErrorMessage>กรุณากรอกข้อมูล ขนาดข้อความไม่ยาวเกิน 200 ตัวอักษร</FormErrorMessage>
                        </FormControl>
                        <FormControl isInvalid={errors.body} >
                            <FormLabel>เนื้อหา</FormLabel>
                            <Controller
                                name="body"
                                control={control}
                                rules={{ maxLength: 200 }}
                                render={({ field }) => <Textarea placeholder="กรอกเนื้อหา(ถ้ามี)" resize={false} {...field} />} />
                            <FormErrorMessage>ขนาดข้อความต้องไม่ยาวเกิน 200 ตัวอักษร</FormErrorMessage>
                        </FormControl>
                        <FormControl isInvalid={errors.note} >
                            <FormLabel>หมายเหตุ</FormLabel>
                            <Controller
                                name="note"
                                control={control}
                                rules={{ maxLength: 200 }}
                                render={({ field }) => <Textarea placeholder="กรอกหมายเหตุ หรือแนะนำขั้นตอนการดำเนินการต่อ(ถ้ามี)" resize={false} {...field} />} />
                            <FormErrorMessage>ขนาดข้อความต้องไม่ยาวเกิน 200 ตัวอักษร</FormErrorMessage>
                        </FormControl>
                        <FormControl isRequired>
                            <FormLabel>ประเภท</FormLabel>
                            <SelectEmailType control={control} isClearable={false} defaultValue={defaultValues.type} />
                        </FormControl>
                    </SectionForm>
                    <HStack w="full" justify="center" pb={3}>
                        <Button type="submit" colorScheme="blue" leftIcon={<BsBoxArrowInDown />}>
                            บันทึกข้อมูล
                        </Button>
                        <Button type="reset" colorScheme="yellow" leftIcon={<BsArrowCounterclockwise />} onClick={() => resetForm()}>
                            ล้างฟอร์ม
                        </Button>
                        <Button leftIcon={<BsX />} colorScheme="red" onClick={close}>
                            ยกเลิก
                        </Button>
                    </HStack>
                </VStack>
            </form>
        </Flex>
    )
}

export default EmailForm